import { render, staticRenderFns } from "./tbqd.vue?vue&type=template&id=4719133b&scoped=true&"
import script from "./tbqd.vue?vue&type=script&lang=js&"
export * from "./tbqd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4719133b",
  null
  
)

export default component.exports